var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"widget-icon"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isUp),expression:"!isUp"}],staticClass:"fas fa-angle-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUp),expression:"isUp"}],staticClass:"fas fa-angle-up"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5574b52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/src/components/Widgets/AngleDownUp.vue
// module id = /rSO
// module chunks = 0 1